<template>
  <CycleFormSet>
    <template #heading>
      <ProvidedText name="paymentDetails.header" />
    </template>

    <ProvidedHtml name="paymentDetails.content.paymentType" />

    <CycleInputContainer>
      <template slot="label">
        <ProvidedText name="paymentDetails.labels.iban" />
        <ProvidedTooltip
          heading-name="paymentDetails.labels.iban"
          body-name="paymentDetails.tooltips.iban"
        />
      </template>
      <CycleTextInput v-model="formData.paymentDetails.iban" required iban-dutch autocomplete="off">
        <ProvidedText name="paymentDetails.placeholders.iban" />
      </CycleTextInput>
    </CycleInputContainer>

    <CycleInputContainer>
      <template slot="label">
        <ProvidedText
          name="paymentDetails.labels.paymentTermYear"
          v-if="paymentDetails.paymentTerm === PaymentTerm.Yearly"
        />
        <ProvidedText
          name="paymentDetails.labels.paymentTermMonth"
          v-if="paymentDetails.paymentTerm === PaymentTerm.Monthly"
        />
        <ProvidedText
          name="paymentDetails.labels.paymentTermSingle"
          v-if="paymentDetails.paymentTerm === PaymentTerm.Single"
        />
      </template>
      {{ paymentDetails.premium | CycleCurrency({ locale }) }}
    </CycleInputContainer>

    <ProvidedHtml v-if="existingCustomer" name="paymentDetails.content.existingCustomer" />
    <ProvidedHtml :name="premiumInfo" />

    <ProvidedTooltip
      heading-name="paymentDetails.headings.premiumTaxes"
      body-name="paymentDetails.tooltips.premiumTaxes"
    />
  </CycleFormSet>
</template>

<script>
import { intlMixin } from '@/mixins'
import { CycleCurrency } from '@/filters'
import { CycleTextInput } from '@/components/elements/forms'
import { CycleTooltip } from '@/components/cycle-tooltip'
import { CycleFormPage, CycleFormSet, CycleInputContainer } from '@/components/functional/forms'
import { ProvidedHtml, ProvidedText, ProvidedTooltip } from '../Content'
import { PaymentDetails, PaymentTerm } from '@/models'

export default {
  name: 'PaymentDetailsForm',
  components: {
    CycleTextInput,
    CycleTooltip,
    CycleFormPage,
    CycleFormSet,
    CycleInputContainer,
    ProvidedHtml,
    ProvidedText,
    ProvidedTooltip
  },
  inject: ['formData'],
  filters: {
    CycleCurrency
  },
  mixins: [intlMixin],
  props: {
    paymentDetails: {
      type: PaymentDetails,
      required: true
    },
    existingCustomer: {
      type: Boolean,
      default: false
    },
    premiumInfo: {
      type: String,
      default: 'paymentDetails.content.premiumInfoProlongation'
    }
  },
  data: () => ({
    PaymentTerm
  }),
  watch: {
    paymentDetails: {
      immediate: true,
      handler(value) {
        this.$set(this.formData, 'paymentDetails', value)
      }
    }
  }
}
</script>
